export default {
    data() {
        return {
            items: [],
            routers: [
                {
                    name: 'home',
                    parent: null,
                    text: () => this.$t('首頁'),
                    to: () => ({ name: 'home' })
                },
                {
                    name: 'contact',
                    parent: 'home',
                    text: () => this.$t('聯絡我們'),
                    to: () => ({ name: 'contact' })
                },
                {
                    name: 'help',
                    parent: 'home',
                    text: () => this.$t('常見問題'),
                    to: () => ({ name: 'help' })
                },
                {
                    name: 'terms-of-use',
                    parent: 'home',
                    text: () => this.$t('使用者條款與隱私權政策'),
                    to: () => ({ name: 'terms-of-use' })
                },
                {
                    name: 'farms.list',
                    parent: 'home',
                    text: () => this.$t('農場列表'),
                    to: () => ({ name: 'farms.list' })
                },
                {
                    name: 'farms.create',
                    parent: 'farms.list',
                    text: () => this.$t('建立農場'),
                    to: () => ({ name: 'farms.create' })
                },
                {
                    name: 'farms.overview',
                    parent: 'farms.list',
                    text: () => this.$t('我的農場'),
                    to: () => ({
                        name: 'farms.overview',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                },
                {
                    name: 'farms.calendar',
                    parent: 'farms.overview',
                    text: () => this.$t('行事曆'),
                    to: () => ({
                        name: 'farms.calendar',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                },
                {
                    name: 'farms.update',
                    parent: 'farms.overview',
                    text: () => this.$t('更新農場'),
                    to: () => ({
                        name: 'farms.update',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                },
                {
                    name: 'farms.cycles.create',
                    parent: 'farms.overview',
                    text: () => this.$t('建立週期'),
                    to: () => ({
                        name: 'farms.cycles.create',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                },
                {
                    name: 'farms.cycles.overview',
                    parent: 'farms.overview',
                    text: () => this.$t('週期'),
                    to: () => {
                        let { id, cycle } = this.$route.params;
                        return {
                            name: 'farms.cycles.overview',
                            params: {
                                id,
                                cycle
                            }
                        };
                    }
                },
                {
                    name: 'farms.cycles.pictures',
                    parent: 'farms.overview',
                    text: () => this.$t('週期'),
                    to: () => {
                        let { id, cycle } = this.$route.params;
                        return {
                            name: 'farms.cycles.overview',
                            params: {
                                id,
                                cycle
                            }
                        };
                    }
                },
                {
                    name: 'farms.cycles.timeline',
                    parent: 'farms.overview',
                    text: () => this.$t('週期'),
                    to: () => {
                        let { id, cycle } = this.$route.params;
                        return {
                            name: 'farms.cycles.timeline',
                            params: {
                                id,
                                cycle
                            }
                        };
                    }
                },
                {
                    name: 'farms.cycles.table',
                    parent: 'farms.overview',
                    text: () => this.$t('週期'),
                    to: () => {
                        let { id, cycle } = this.$route.params;
                        return {
                            name: 'farms.cycles.table',
                            params: {
                                id,
                                cycle
                            }
                        };
                    }
                }
            ]
        };
    },
    watch: {
        '$route': {
            deep: true,
            handler() {
                this.updateRouter();
            }
        }
    },
    mounted() {
        this.updateRouter();
    },
    methods: {
        updateRouter() {
            this.items = this.getItems(this.$route.name).reverse();
            this.$forceUpdate();
        },
        getItems(name, items = []) {
            let here = this.routers.find(item => {
                return item.name === name;
            });
            if (here) {
                items.push({
                    name: here.name,
                    text: here.text(),
                    to: here.to()
                });
                if (here.parent) {
                    this.getItems(here.parent, items);
                }
            }
            return items;
        }
    }
};
